import React from 'react'
import './digitalhub.css'

function Digitalhub() {
  return (
    <div>
      <h1>Digital Hub  </h1>
    </div>
  )
}

export default Digitalhub
